export default __webpack_public_path__ + "static/media/adugbo.06b18854.png";